import { useDispatch, useSelector } from "react-redux";

import { getNmckList } from "slices/nmck/nmckSelectors";
import { nmckActions } from "slices/nmck/nmckSlice";
import { addToNmckGroup } from "slices/nmck/services/addToNmckGroup";
import { deleteFromNmckGroup } from "slices/nmck/services/deleteFromNmckGroup";

export const useDragHandlers = () => {
	const dispatch = useDispatch();
	const nmckList = useSelector(getNmckList);
	const setNmckList = (newValue) => dispatch(nmckActions.setNmckList(newValue));

	const onDragEnd = (result) => {
		const targetIndex = result.destination?.index;
		const targetDropId = result.destination?.droppableId;
		const targetEntity = nmckList[targetIndex];
		const sourceIndex = result.source?.index;
		const sourceDropId = result.source?.droppableId;

		if (!targetDropId || targetDropId === "nmckList") {
			const getFilteredNmckList = ({ groupId, nmckId }) =>
				nmckList.map((item) => {
					if (item.group_id === groupId) {
						return {
							...item,
							_children: item._children.filter((child) => child.id !== nmckId),
						};
					}
					return item;
				});

			if (targetEntity?.type === "Group") {
				let sourceNmckId;
				let sourceGroupId = null;
				const targetGroupId = targetEntity.group_id;

				if (sourceDropId === "nmckList") {
					sourceNmckId = nmckList[sourceIndex].id;
				} else {
					const sourceGroupIndex = parseInt(sourceDropId, 10);
					if (Number.isNaN(sourceGroupIndex)) return;
					const sourceGroup = nmckList[sourceGroupIndex];
					sourceGroupId = sourceGroup.group_id;
					sourceNmckId = sourceGroup._children[sourceIndex].id;

					if (targetGroupId === sourceGroup.group_id) return;
				}

				setNmckList(
					getFilteredNmckList({
						groupId: sourceGroupId,
						nmckId: sourceNmckId,
					})
				);

				dispatch(
					addToNmckGroup({
						groupId: targetGroupId,
						nmckId: sourceNmckId,
					})
				);
			} else {
				if (sourceDropId === "nmckList") return;

				const sourceGroupIndex = parseInt(sourceDropId, 10);
				if (Number.isNaN(sourceGroupIndex)) return;
				const sourceGroup = nmckList[sourceGroupIndex];
				const sourceGroupId = sourceGroup.group_id;
				const sourceNmck = sourceGroup._children[sourceIndex];
				const sourceNmckId = sourceNmck.id;

				setNmckList(
					getFilteredNmckList({
						groupId: sourceGroupId,
						nmckId: sourceNmckId,
					})
				);

				dispatch(
					deleteFromNmckGroup({
						groupId: sourceGroupId,
						nmckId: sourceNmckId,
					})
				);
			}
		}
	};

	return { onDragEnd };
};
